import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import { ButtonSharedService } from './button.sharedService';

@Component({
  selector: 'reset-selection',
  template: `
  <button type="button" axis-button data-kind="icon" class="axis-toggle-reset"
    (click)="resetSelection()" [disabled]="buttonToggleInstance?.disabled">
       <axis-icon [font]="buttonToggleInstance?.font" icon="clear"></axis-icon>
  </button>
    `
})
export class AxisResetSelectionComponent implements OnInit, OnDestroy {
  public uniqueKey: number;
  public buttonToggleInstance: any;

  constructor(public buttonSharedService: ButtonSharedService, private changeDetectorRef: ChangeDetectorRef) { }
  ngOnInit() {
    this.buttonToggleInstance = this.buttonSharedService.getInstance(
      this.uniqueKey
    );
  }
  markForCheck() {
    this.changeDetectorRef.detectChanges();
  }
  resetSelection() {
    this.buttonToggleInstance.resetAll();
  }
  ngOnDestroy() {
    this.buttonToggleInstance = null;
    this.buttonSharedService.destroyInstance(this.uniqueKey);
  }
}
